<template>
	<div class="edit-mode">
		<v-expansion-panels v-model="panel" flat accordion>
			<ExpansionPanel :title="'Basics'">
				<div class="title-text">Text</div>
				<CombinedInputFieldDataMenu
					class="mb-6"
					:textAreaMode="true"
					:value.sync="outputValueLocal"
					:valuesTypes="dataInputMenuValueTypes"
					:richTextFormat="richTextFormat"
				/>
				<SettingSwitch
					:title="'Label'"
					:placeholder="'Type your title here'"
					:switchValue.sync="titleEnabledWrapper"
					:textFieldValue.sync="titleValue"
				/>
			</ExpansionPanel>
		</v-expansion-panels>
	</div>
</template>

<script>
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';

import { TEXT_BOX_FORMAT_TYPES } from '@/components/common/RichTextBox/rich-text-box.const';

import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';

import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import SettingSwitch from './WidgetSettings/SettingSwitch';

export default {
	name: 'TextOutputFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		ExpansionPanel,
		CombinedInputFieldDataMenu,
		SettingSwitch,
	},
	computed: {
		outputValueLocal: {
			set(value) {
				this.setLocalFieldKey('metadata.output.value', value);
			},
			get() {
				return this.localField.metadata.output?.value;
			},
		},
		titleEnabledWrapper: {
			set(value) {
				this.titleEnabled = value;
			},
			get() {
				// HACK: this is for back support of old (already enabled) TextOutput titles
				return this.needsBackSupportForHack ? false : this.titleEnabled;
			},
		},
	},
	mounted() {
		this.needsBackSupportForHack = ['', null, undefined, 'Text Output label'].includes(this.titleValue);
	},
	watch: {
		titleEnabled: {
			handler(newV, oldV) {
				if (newV && oldV !== undefined) {
					if ('Text Output label' === this.titleValue) {
						this.$set(this, 'titleValue', 'Text label');
					}
					this.$set(this, 'needsBackSupportForHack', false);
				}
			},
			immediate: true,
		},
	},
	data() {
		return { richTextFormat: TEXT_BOX_FORMAT_TYPES.HTML, needsBackSupportForHack: false };
	},
};
</script>

<style scoped lang="scss">
.edit-mode {
	.title-text {
		font-size: 14px;
		font-weight: 400;
		text-align: left;
	}
	::v-deep {
		// the following is in order to allow "line auto grow"
		.CodeMirror {
			border: 1px solid #eee;
			height: auto !important;
		}
		.CodeMirror-scroll {
			overflow-y: hidden !important;
			overflow-x: auto !important;
		}
	}
	::v-deep {
		.menu-container {
			position: relative;
			.data-input-menu-layout {
				position: relative;
			}
		}
	}
}
</style>
